<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 3.33317C6.31812 3.33317 3.33335 6.31794 3.33335 9.99984C3.33335 13.6817 6.31812 16.6665 10 16.6665C13.1593 16.6665 15.8054 14.4689 16.4928 11.5189L16.1725 11.8392C15.847 12.1646 15.3194 12.1645 14.994 11.839C14.6686 11.5135 14.6687 10.9859 14.9941 10.6605L16.6613 8.99383C16.8176 8.83757 17.0296 8.7498 17.2506 8.74984C17.4716 8.74987 17.6836 8.8377 17.8398 8.994L19.506 10.6607C19.8314 10.9862 19.8313 11.5138 19.5058 11.8392C19.1803 12.1646 18.6527 12.1645 18.3273 11.839L18.1647 11.6763C17.3888 15.4752 14.0282 18.3332 10 18.3332C5.39765 18.3332 1.66669 14.6022 1.66669 9.99984C1.66669 5.39746 5.39765 1.6665 10 1.6665C13.0584 1.6665 15.7309 3.31449 17.1796 5.7669C17.4137 6.16317 17.2822 6.67416 16.886 6.90824C16.4897 7.14232 15.9787 7.01085 15.7446 6.61459C14.5833 4.64874 12.4449 3.33317 10 3.33317ZM10 4.99984C10.4603 4.99984 10.8334 5.37293 10.8334 5.83317V9.55385L12.9623 10.9731C13.3452 11.2284 13.4487 11.7458 13.1934 12.1288C12.9381 12.5117 12.4207 12.6152 12.0378 12.3599L9.53777 10.6932C9.30594 10.5387 9.16669 10.2785 9.16669 9.99984V5.83317C9.16669 5.37293 9.53978 4.99984 10 4.99984Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
